// extracted by mini-css-extract-plugin
export default {"empty":"PurchaseList_empty__Y1S35","item":"PurchaseList_item__Ueojm"};